import styles from './Tooltip.module.css';

const Tooltip = ({ text, children, wide }) => {
  return (
    <div className={styles.wrapper}>
      {children}
      <div className={`${styles.box} ${wide ? styles.wide : ''}`} role="tooltip">{text}</div>
    </div>
  );
};

export default Tooltip;
